exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2ikiz{z-index:50;width:100%;height:100%}._2ikiz,._2R_dm{position:relative}.IXTKl{height:0;width:0;visibility:hidden}", ""]);

// exports
exports.locals = {
	"playerContainer": "_2ikiz",
	"mainContainer": "_2R_dm",
	"mockedVideo": "IXTKl"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--10-1!../node_modules/postcss-loader/lib??ref--10-2!../node_modules/sass-loader/lib/loader.js??ref--10-3!./ui/player-container.scss
// module id = 226
// module chunks = 0